module.exports = __webpack_public_path__ + "img/icon-39.6e78a0a2.png";